import {
  Alert,
  AlertTitle,
  Box,
  Container,
  Divider,
  Grid,
  Snackbar,
  TextField,
} from "@mui/material";
import LoadingButton from "@mui/lab/LoadingButton";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getManageBookingData } from "../redux/actions/AdminAction";
import { useNavigate } from "react-router-dom";
import { CHECK_PCC_RESET } from "../Constants/Constants";

export default function ManageItinerary(props) {
  const { decodedToken } = props;
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [PNR, setPNR] = useState();
  const [PCC, setPCC] = useState();

  const [errorAlert, setErrorAlert] = useState(false);
  const [errorAlertMessage, setErrorAlertMessage] = useState("");
  const [errorAlertTitle, setErrorAlertTitle] = useState("");
  const [snackOpen, setSnackOpen] = useState(false);

  const GetManageBookingData = useSelector(
    (state) => state.GetManageBookingData
  );

  const { loading, itineraryInfo, error } = GetManageBookingData;

  const handleSnackClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setSnackOpen(false);
    setErrorAlert(false);
  };

  useEffect(() => {
    dispatch({ type: CHECK_PCC_RESET });
  }, []);

  useEffect(() => {
    if (!loading) {
      if (itineraryInfo && !error) {
        sessionStorage.setItem("pnr", PNR);
        sessionStorage.setItem("pcc", PCC);
        navigate("/managemyitineraryresult");
      } else if (error) {
        setErrorAlertTitle("Error");
        setErrorAlertMessage(error);
        setSnackOpen(true);
        setErrorAlert(true);
      }
    }
  }, [loading, itineraryInfo, error]);

  const handleItineraryDisplay = () => {
    if (PNR && PCC) {
      dispatch(getManageBookingData(PNR, PCC, decodedToken?.role));
    } else {
      setErrorAlertTitle("Required field error");
      setErrorAlertMessage(
        "Please enter all the fields. PNR and PCC are required."
      );
      setSnackOpen(true);
      setErrorAlert(true);
    }
  };
  return (
    <Container sx={{ marginBottom: "20.2%" }}>
      <Box sx={{ margin: 3, fontSize: 25, textAlign: "center" }}>
        Manage My Booking
        <Divider sx={{ marginTop: 2 }}></Divider>
      </Box>
      <Box sx={{ margin: 3, marginTop: 10 }}>
        <Grid container sx={{ marginTop: 3, textAlign: "center" }}>
          <Grid item xs={12} mt={2}>
            <Grid item xs={12}>
              Enter Booking PNR
            </Grid>
            <Grid item xs={12} mt={2}>
              <TextField
                sx={{ width: "40%" }}
                required
                value={PNR}
                onChange={(e) => setPNR(e.target.value.toUpperCase())}
              />
            </Grid>
          </Grid>
          <Grid item xs={12} mt={5}>
            <Grid item xs={12}>
              Enter PCC (Where PNR made in)
            </Grid>
            <Grid item xs={12} mt={2}>
              <TextField
                sx={{ width: "40%" }}
                required
                value={PCC}
                onChange={(e) => setPCC(e.target.value.toUpperCase())}
              />
            </Grid>
          </Grid>
          <Grid item xs={12} mt={6}>
            <LoadingButton
              loading={loading}
              variant="contained"
              loadingPosition="start"
              type="submit"
              sx={{ backgroundColor: "#282828", width: "15%" }}
              onClick={handleItineraryDisplay}
            >
              submit
            </LoadingButton>
          </Grid>
        </Grid>
        {errorAlert && (
          <Snackbar
            open={snackOpen}
            autoHideDuration={5000}
            onClose={handleSnackClose}
            anchorOrigin={{ vertical: "top", horizontal: "center" }}
            sx={{ width: "20%" }}
          >
            <Alert
              onClose={handleSnackClose}
              severity="error"
              sx={{ width: "100%" }}
            >
              <AlertTitle>{errorAlertTitle}</AlertTitle>
              {errorAlertMessage}
            </Alert>
          </Snackbar>
        )}
      </Box>
    </Container>
  );
}
